import { BindAll } from "lodash-decorators";

@BindAll()
export class MySettingsController {}